import * as React from "react";

import {Role} from "../../api/Role";
import {AppCtx} from "../../ioc/ApplicationContext";
import {UserStoreState} from "../../store/UserStore";

export class RequiresAdminRole extends React.Component<{ children?: any }, { role: string }> {

    unsubscribe: () => void;

    constructor(props) {
        super(props);
        this.state = {role: AppCtx.getUserStore().getState().activeRole};
    }

    componentDidMount() {
        this.unsubscribe = AppCtx.getUserStore().listen((state: UserStoreState) => {
            this.setState({role: state.activeRole})
        });
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    hasRole() {
        return this.state.role == Role.ADMIN;
    }

    render() {
        if (!this.hasRole()) {
            return <div/>;
        }
        return (
            <div>{this.props.children}</div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/app/ui/util/RequiresAdminRole.tsx